import React from 'react'
import StatusPill from 'src/components/ts-components/StatusPill'
import type { RosterPillConfig } from '../constants/rosterStatusPills'

interface RosterPillProps {
  config: RosterPillConfig
}

/** A roster Status pill from its label / icon / colour config. */
const RosterPill: React.FC<RosterPillProps> = ({
  config: { label, Icon, color },
}) => <StatusPill label={label} icon={<Icon />} backgroundColor={color} />

export default RosterPill
